import RmSetTriggerAlarmModal from './rm-set-trigger-alarm-modal.vue'
export default RmSetTriggerAlarmModal
